export type Button = 'icon' | 'line' | 'default';

export enum ButtonType {
  I = 'icon',
  L = 'line',
  D = 'default',
}

export interface Props extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'type'> {
  text?: string;
  icon?: string;
  type?: Button;
  active?: boolean;
  primary?: boolean;
  selected?: boolean;
  className?: string;
  isLoading?: boolean;
  // onClick: () => void;
}
